import { ChipProps } from "@mui/material"
import { GuestBot } from "../interfaces"

export const JOIN_JOB_STATUS_LABEL: Record<GuestBot.JoinJobStatus, string> = {
  draft: "Не запущено",
  joining: "Идёт вступление",
  awaiting_approval: "Ожидает одобрения заявок",
  completed: "Завершено",
  failed: "Ошибка",
  cancelled: "Отменено",
}
export const JOIN_JOB_STATUS_COLOR: Record<
  GuestBot.JoinJobStatus,
  ChipProps["color"]
> = {
  draft: "default",
  joining: "info",
  awaiting_approval: "warning",
  completed: "success",
  failed: "error",
  cancelled: "default",
}
export const JOIN_LINK_STATUS_LABEL: Record<GuestBot.JoinLinkStatus, string> = {
  pending_join: "В очереди",
  joined: "Вступили",
  approval_pending: "Заявка на одобрении",
  failed: "Ошибка",
  cancelled: "Отменено",
}
export const JOIN_LINK_STATUS_COLOR: Record<
  GuestBot.JoinLinkStatus,
  ChipProps["color"]
> = {
  pending_join: "default",
  joined: "success",
  approval_pending: "warning",
  failed: "error",
  cancelled: "default",
}
export const MAILING_STATUS_LABEL: Record<GuestBot.MailingStatus, string> = {
  draft: "Запускается…",
  sending: "Идёт рассылка",
  completed: "Завершена",
  failed: "Ошибка",
  cancelled: "Отменена",
}
export const MAILING_STATUS_COLOR: Record<
  GuestBot.MailingStatus,
  ChipProps["color"]
> = {
  draft: "default",
  sending: "info",
  completed: "success",
  failed: "error",
  cancelled: "default",
}
export const MAILING_CHAT_STATUS_LABEL: Record<
  GuestBot.MailingChatStatus,
  string
> = {
  pending: "Ожидает",
  sent: "Отправлено",
  deleted: "Отправлено и удалено",
  failed: "Ошибка",
  cancelled: "Отменено",
}
export const MAILING_CHAT_STATUS_COLOR: Record<
  GuestBot.MailingChatStatus,
  ChipProps["color"]
> = {
  pending: "default",
  sent: "success",
  deleted: "default",
  failed: "error",
  cancelled: "default",
}
export const isJoinJobTerminal = (s: GuestBot.JoinJobStatus): boolean =>
  s === "completed" || s === "failed" || s === "cancelled"
export const isMailingTerminal = (s: GuestBot.MailingStatus): boolean =>
  s === "completed" || s === "failed" || s === "cancelled"
export const CHATS_POLL_MS = 5000
